module.exports = __webpack_public_path__ + "img/logo.8adbd64f.png";